/**
 * Engraving Configuration Constants
 * Shared configuration for engraving text scaling across modal and basket displays
 *
 * ENGRAVING_ALLOWED_CHARS: characters the CNC machine can engrave (from AllCharacters.json).
 * sanitizeEngravingInput: restricts input to those characters only (plus newline and pipe | for line breaks).
 */

// Characters the CNC machine can engrave (extracted from AllCharacters.json)
var ENGRAVING_ALLOWED_CHARS = " 0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz\u00a1\u00bf\u00c0\u00c1\u00c2\u00c4\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cd\u00ce\u00cf\u00d1\u00d3\u00d4\u00d6\u00d9\u00da\u00db\u00dc\u00df\u00e0\u00e1\u00e2\u00e4\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ed\u00ee\u00ef\u00f1\u00f3\u00f4\u00f6\u00f9\u00fa\u00fb\u00fc\u00ff\u0152\u0153\u0178\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039a\u039b\u039c\u039d\u039e\u039f\u03a0\u03a1\u03a3\u03a4\u03a5\u03a6\u03a7\u03a8\u03a9\u03b1\u03b2\u03b3\u03b4\u03b5\u03b6\u03b7\u03b8\u03b9\u03ba\u03bb\u03bc\u03bd\u03be\u03bf\u03c0\u03c1\u03c2\u03c3\u03c4\u03c5\u03c6\u03c7\u03c8\u03c9\u1e9e";

// Allow newline and pipe (|) for line breaks; pipe forces a new line in display and is stored in properties
var ENGRAVING_ALLOWED_CHARS_WITH_NL = ENGRAVING_ALLOWED_CHARS + '\n|';

function sanitizeEngravingInput(str) {
  if (typeof str !== 'string') return '';
  var allowed = ENGRAVING_ALLOWED_CHARS_WITH_NL;
  if (allowed.indexOf('|') === -1) allowed += '|';
  return Array.from(str).filter(function (c) {
    return allowed.indexOf(c) !== -1;
  }).join('');
}

// Non-empty value sent for blank engraving positions so Shopify Cart API keeps the property (it omits empty strings)
var ENGRAVING_BLANK_PLACEHOLDER = ' ';

const EngravingConfig = {
  BASE_FONT_SIZE: 12,
  BASE_WIDTH: 400,
  BASE_MAX_WIDTH: 80,
  MAX_IMAGE_WIDTH: 320,
  PLATE_WIDTH_DIVISOR: 146
};

window.EngravingConfig = EngravingConfig;
window.ENGRAVING_BLANK_PLACEHOLDER = ENGRAVING_BLANK_PLACEHOLDER;
window.ENGRAVING_ALLOWED_CHARS = ENGRAVING_ALLOWED_CHARS;
window.sanitizeEngravingInput = sanitizeEngravingInput;
